/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { GetBranchKPIPerformanceResponse } from '../models/GetBranchKPIPerformanceResponse';
import type { GetSalePerformanceTargetResponse } from '../models/GetSalePerformanceTargetResponse';
import type { GetWeeklySalesResponse } from '../models/GetWeeklySalesResponse';
import type { GetWeeklySalesTeamResponse } from '../models/GetWeeklySalesTeamResponse';
import type { SaleBranchCategoryReportInput } from '../models/SaleBranchCategoryReportInput';
import type { SaleBranchCategoryReportResponse } from '../models/SaleBranchCategoryReportResponse';
import type { SalePerfomanceFieldColorModel } from '../models/SalePerfomanceFieldColorModel';
import type { SalePerfomanceFieldColors } from '../models/SalePerfomanceFieldColors';
import type { SalePerfomanceSalesExecIdentModel } from '../models/SalePerfomanceSalesExecIdentModel';
import type { SalePerfomanceSalesExecModel } from '../models/SalePerfomanceSalesExecModel';
import type { SalePerformanceKpiModel } from '../models/SalePerformanceKpiModel';
import type { SalesPerformanceCommissionCreateInput } from '../models/SalesPerformanceCommissionCreateInput';
import type { SalesPerformanceCommissionDto } from '../models/SalesPerformanceCommissionDto';
import type { SalesPerformanceCommissionDtoPagedListData } from '../models/SalesPerformanceCommissionDtoPagedListData';
import type { SalesPerformanceCommissionUpdateInput } from '../models/SalesPerformanceCommissionUpdateInput';
import type { SalesPerformanceReportType } from '../models/SalesPerformanceReportType';
import type { SaveSalePerformanceTargetRequest } from '../models/SaveSalePerformanceTargetRequest';
import type { UserRole } from '../models/UserRole';
import type { WeeklyObjectiveModel } from '../models/WeeklyObjectiveModel';

import { PerfomanceReport } from 'features/sales/executor/api/models/sales-executor';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { SalePerfomanceBranchEmployeeDTO } from '../models/SalePerfomanceBranchEmployeeDTO';
import { SalePerfomanceBranchEmployeeInput } from '../models/SalePerfomanceBranchEmployeeInput';

export class SalesPerfomanceService {

  /**
   * @param from 
   * @param to 
   * @param reportType
 *
 * 1 = Delivered
 *
 * 2 = Invoiced
   * @param branchId 
   * @param roleId
 *
 * 0 = DefaultEmployee (Роль по умолчанию, минимум возможностей)
 *
 * 1 = Administrator (Имеет доступ ко всем страницам и всему функционалу)
 *
 * 2 = Accountant (Бухгалтер)
 *
 * 3 = BdcAdvisor
 *
 * 4 = BodyshopManager
 *
 * 5 = PartsDriver
 *
 * 6 = PartsManager
 *
 * 7 = SalesAdministrator
 *
 * 8 = SalesConsultant (Анжела его еще называет Sales Exec)
 *
 * 9 = SalesManager
 *
 * 10 = ServiceAdvisor
 *
 * 11 = ServiceDriver
 *
 * 12 = ServiceManager
 *
 * 13 = SiteCoordinator
 *
 * 14 = Valetor
 *
 * 15 = Technician
 *
 * 16 = CarBuyer
 *
 * 17 = BodyshopOperative
 *
 * 18 = Marketing
 *
 * 19 = Maintenance
   * @param jobTitle 
   * @returns SalePerfomanceSalesExecModel Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetPerformance(
from?: string,
to?: string,
reportType?: SalesPerformanceReportType,
branchId?: number,
roleId?: UserRole,
jobTitle?: string,
): CancelablePromise<Array<SalePerfomanceSalesExecModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetPerformance',
      query: {
        'from': from,
        'to': to,
        'reportType': reportType,
        'branchId': branchId,
        'roleId': roleId,
        'jobTitle': jobTitle,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
 * @param from 
 * @param to 
 * @param reportType
 *
 * 1 = Delivered
 *
 * 2 = Invoiced
 * @param branchId 
 * @param roleId 
 * @returns void Success
 * @throws ApiError
 */
public static saveSalesCommission(
  from?: string,
  to?: string,
  reportType?: PerfomanceReport,
  branchId?: number,
  roleId?: number,
): CancelablePromise<void> {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/SalesPerfomance/SaveCommission',
    query: {
      'from': from,
      'to': to,
      'reportType': reportType,
      'branchId': branchId,
      'roleId': roleId,
    },
    errors: {
      400: `Bad Request`,
      500: `Server Error`,
    },
  });
}

  /**
   * @param month 
   * @param year 
   * @returns GetSalePerformanceTargetResponse Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetPerformanceTarget(
month?: number,
year?: number,
): CancelablePromise<Array<GetSalePerformanceTargetResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetPerformanceTarget',
      query: {
        'month': month,
        'year': year,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postSalesPerfomanceSavePerformanceTarget(
requestBody?: Array<SaveSalePerformanceTargetRequest>,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SalesPerfomance/SavePerformanceTarget',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param date 
   * @param reportType
 *
 * 1 = Delivered
 *
 * 2 = Invoiced
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns GetBranchKPIPerformanceResponse Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetBranchKpiPerformance(
date: string,
reportType: SalesPerformanceReportType,
branch?: BranchType,
): CancelablePromise<Array<GetBranchKPIPerformanceResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetBranchKPIPerformance',
      query: {
        'date': date,
        'reportType': reportType,
        'branch': branch,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param month 
   * @param year 
   * @param userId 
   * @returns SalePerfomanceSalesExecIdentModel Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetIndividualPerfomance(
month?: number,
year?: number,
userId?: number,
): CancelablePromise<SalePerfomanceSalesExecIdentModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetIndividualPerfomance',
      query: {
        'month': month,
        'year': year,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param date 
   * @returns SalePerfomanceFieldColorModel Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetPerformanceColors(
date: string,
): CancelablePromise<Array<SalePerfomanceFieldColorModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetPerformanceColors',
      query: {
        'date': date,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postSalesPerfomanceSavePerformanceColors(
formData?: {
Date: string;
FieldName: string;
Color: SalePerfomanceFieldColors;
Branch: BranchType;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SalesPerfomance/SavePerformanceColors',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param from 
   * @param to 
   * @param branchId 
   * @returns SalePerformanceKpiModel Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetPerformanceReportKpi(
from?: string,
to?: string,
branchId?: number,
): CancelablePromise<Array<SalePerformanceKpiModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetPerformanceReportKpi',
      query: {
        'from': from,
        'to': to,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param period 
   * @param reportType
 *
 * 1 = Delivered
 *
 * 2 = Invoiced
   * @param branchId 
   * @returns SaleBranchCategoryReportResponse Success
   * @throws ApiError
   */
  public static getSalesPerfomanceGetSaleBranchCategoryReportData(
period?: string,
reportType?: SalesPerformanceReportType,
branchId?: number,
): CancelablePromise<SaleBranchCategoryReportResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/GetSaleBranchCategoryReportData',
      query: {
        'period': period,
        'reportType': reportType,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSalesPerfomanceSaveSaleBranchCategoryReportData(
requestBody?: SaleBranchCategoryReportInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SalesPerfomance/SaveSaleBranchCategoryReportData',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postSalesPerfomanceCommissions(
requestBody?: SalesPerformanceCommissionCreateInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SalesPerfomance/commissions',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns SalesPerformanceCommissionDtoPagedListData Success
   * @throws ApiError
   */
  public static getSalesPerfomanceCommissions(
dateFrom?: string,
dateTo?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<SalesPerformanceCommissionDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/commissions',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns SalesPerformanceCommissionDto Success
   * @throws ApiError
   */
  public static getSalesPerfomanceCommissions1(
id: number,
): CancelablePromise<SalesPerformanceCommissionDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/SalesPerfomance/commissions/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putSalesPerfomanceCommissions(
id: number,
requestBody?: SalesPerformanceCommissionUpdateInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/SalesPerfomance/commissions/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteSalesPerfomanceCommissions(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/SalesPerfomance/commissions/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

/**
   * @param from 
   * @param to 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
   * @returns GetWeeklySalesTeamResponse Success
   * @throws ApiError
   */
public static getPerfomanceSalesWeekly(
  from: string,
  to: string,
  branch?: BranchType,
  ): CancelablePromise<GetWeeklySalesTeamResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/perfomance/sales/weekly',
        query: {
          'From': from,
          'To': to,
          'Branch': branch,
        },
        errors: {
          400: `Bad Request`,
          500: `Server Error`,
        },
      });
    }
  
    /**
     * @param id 
     * @param from 
     * @param to 
     * @returns GetWeeklySalesResponse Success
     * @throws ApiError
     */
    public static getPerfomanceSalesWeekly1(
  id: number,
  from: string,
  to: string,
  ): CancelablePromise<GetWeeklySalesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/perfomance/sales/weekly/{id}',
        path: {
          'id': id,
        },
        query: {
          'from': from,
          'to': to,
        },
        errors: {
          400: `Bad Request`,
          500: `Server Error`,
        },
      });
    }
  
    /**
     * @param requestBody 
     * @returns any Created
     * @throws ApiError
     */
    public static postPerfomanceSalesWeeklyTargets(
  requestBody?: WeeklyObjectiveModel,
  ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/perfomance/sales/weekly/targets',
        body: requestBody,
        mediaType: 'application/json-patch+json',
        errors: {
          400: `Bad Request`,
          500: `Server Error`,
        },
      });
    }


  /**
   * @param requestBody
   * @returns any Created
   * @throws ApiError
   */
  public static postServiceAdvisorEmployees(
    requestBody?: SalePerfomanceBranchEmployeeInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-advisor/employees',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId
   *
   * 1 = Slough
   *
   * 2 = HighWycombe
   *
   * 3 = Maidenhead
   *
   * 4 = Watford
   *
   * 6 = HemelHempstead
   *
   * 7 = Romford
   * @param dateFrom
   * @param dateTo
   * @param showDeleted
   * @returns SalePerfomanceBranchEmployeeDTO Success
   * @throws ApiError
   */
  public static getServiceAdvisorEmployees(
    branchId: Array<BranchType>,
    dateFrom?: string,
    dateTo?: string,
    showDeleted: boolean = false,
  ): CancelablePromise<Array<SalePerfomanceBranchEmployeeDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-advisor/employees',
      query: {
        'branchId': branchId,
        'dateFrom': dateFrom,
        'dateTo': dateTo,
        'showDeleted': showDeleted,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteServiceAdvisorEmployees(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-advisor/employees/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
